export default {
    env : process.env.NODE_ENV,

    /** Dev Settings */

    api_env: process.env.VUE_APP_API_PATH,
    zen_desk_key: process.env.ZEN_DESK_KEY,

    // Hosted Twilio webchat in place of MessageBird (CR-414). Exactly "true" turns it on.
    use_twilio_webchat: process.env.VUE_APP_TWILIO_FLEX_WEB_CHAT === "true",
    webchat_url: process.env.VUE_APP_WEBCHAT_URL,

    /** Other*/
    options: {
        headers: {
            "Content-type": 'application/json'
        }
    },
    encrypt_level: "high",
    adminEmail: "admin@example.com"
};
